import { PricingTierAPI } from '@business/api/order';
import { PricingTierId, PricingTierResponse } from '@business/entities/order';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class PricingTeirBloc extends BaseBloc {
  private readonly tiersRepo = new Repository<PricingTierResponse>({
    getItemId: tier => tier.id,
    sortBy: 'title',
  });

  readonly tiers$ = this.tiersRepo.items$;

  onReset() {
    this.tiersRepo.reset();
  }

  fetchTiers = () => {
    return PricingTierAPI.fetchTiers().pipe(this.tiersRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_pricing_tiers_error') }));
  };

  createTier = (data: Partial<PricingTierResponse>) => {
    return PricingTierAPI.createTier(data).pipe(
      this.tiersRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_pricing_tier'),
      }),
    );
  };

  updateTier = (id: PricingTierId, data: Partial<PricingTierResponse>) => {
    return PricingTierAPI.updateTier(id, data).pipe(
      this.tiersRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_pricing_tier'),
      }),
    );
  };

  deleteTier = (id: PricingTierId) => {
    return showDeleteConfirmation('Delete Tier', `Do you really want to remove this pricing tier?`).pipe(
      switchMap(() => PricingTierAPI.deleteTier(id)),
      this.tiersRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_pricing_tier'),
      }),
    );
  };
}
